import ApiCallerClient, {ApiMethod} from "../clients/apiCallerClient";
import SessionStorageHandler from "./sessionStorageHandler";

export default class LLMAnswerGenerationClient {

    constructor(apiHost) {
        this.apiHost = apiHost;
        this.sessionStorageHandler = new SessionStorageHandler();
    }

    getLLMAnswer = async (query_text) => {
        let cached_value = this.sessionStorageHandler.getItem(query_text);
        if (cached_value) {
            return cached_value;
        }
        
        const path = `/prod`;
        let response =  await ApiCallerClient.callApi({
            "endpoint": {
                "hostName": this.apiHost,
                "httpMethod": ApiMethod.POST,
                "path": path
            },
            "body": JSON.stringify({"query": query_text}, null, 2)
        });
        let answer = JSON.parse(response.body).llm_answer;
        this.sessionStorageHandler.addItem(query_text, answer);
        return answer;
    }
}